import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ContractState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: ContractState = {
  data: [],
  isLoading: false,
  error: null,
};

const ContractSlice = createSlice({
  name: 'contract',
  initialState,
  reducers: {
    setContracts: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setContractLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setContractError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setContracts, setContractLoading, setContractError } = ContractSlice.actions;

export default ContractSlice.reducer;
